import { Pipe, PipeTransform } from '@angular/core'
import { formatDisplayName } from 'libs/shared/utils/helpers/src/lib/format-display-name'

@Pipe({
  name: 'gbDisplayName',
  standalone: true,
})
export class GbDisplayNamePipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(profile?: any): string {
    return formatDisplayName(profile)
  }
}
